var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',[_c('div',{staticClass:"nav"},[_c('Breadcrumb')],1),_c('div',{staticClass:"content-container"},[_c('h1',[_vm._v("演示环境，暂未开放")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }